import React from 'react';
import './style.css'
import TitleSection from './../../component/title'
import ActivitiesImg from './../../assets/activities.png'
import ActivitiesImg2 from './../../assets/activities2.png'
import ActivitiesImg3 from './../../assets/activities3.png'
import ActivitiesImg4 from './../../assets/activities4.png'
import Model from './../../assets/model.png'
import Magic from './../../assets/magic.png'
import SimpleSlider from '../../component/slider';

const Activities=()=>{

    const dataImg = [
        ActivitiesImg,
        ActivitiesImg2,
        ActivitiesImg3,
        ActivitiesImg4
    ]

    return (
        <section className='activities' id='activities'>
            <TitleSection>Activities</TitleSection>
            <div className="activities-container">
                <div className="activities-img">
                    <SimpleSlider dataImage={dataImg}/>
                </div>
                <div className="activities-content">
                    <div className="activities-box">
                        <div className="activities-box-content">
                            <div className="activities-text">
                                <h4>Modeling</h4>
                                <p>Lorem ipsum dolor sit amet consectetur adipisicing.</p>
                            </div>
                            <div className="activities-box-img">
                                <div className="activities-content-img">
                                    <img src={Model} alt=""/>
                                </div>
                            </div>
                        </div>
                        <div className="activities-box-content" style={{backgroundColor:'#ADA3E8'}}>
                            <div className="activities-text">
                                <h4>Magic</h4>
                                <p>Lorem ipsum dolor sit amet consectetur adipisicing.</p>
                            </div>
                            <div className="activities-box-img">
                                <div className="activities-content-img">
                                    <img src={Magic} alt=""/>
                                </div>
                            </div>
                        </div>
                        <div className="activities-box-content" style={{backgroundColor:'#72D9B4'}}>
                            <div className="activities-text">
                                <h4>Dance</h4>
                                <p>Lorem ipsum dolor sit amet consectetur adipisicing.</p>
                            </div>
                            <div className="activities-box-img">
                                <div className="activities-content-img">
                                    <img src={Model} alt=""/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Activities